/* eslint-disable */
import axios from 'axios';
import store from '@/store';
import i18n from '@/lang/lang';

let apiURL = (process.env.NODE_ENV === 'development' ? 'http://0.0.0.0:3000/api/' : 'https://motivac.herokuapp.com/api/');

if (process.env.VUE_APP_ISDEMO === 'true' || process.env.VUE_APP_ISDEMO === true) {
    console.log('\n\n============ VUE RUN IN DEMO MODE! ============\n\n');
    apiURL = 'https://demo-motivac.herokuapp.com/api/';
}

function fetchData(endpoint, requestType, requestBody, contentType) {
    const token = store.state.apiKey;
    const headers = { 'Content-Type': 'application/json', 'Cache-Control': 'no-cache', 'x-api-key': token, 'Accept-Language': i18n.locale };
    if (contentType) {
        headers['Content-Type'] = contentType;
    }
    return axios({
        method: requestType,
        url: endpoint,
        data: requestBody,
        headers,
    }).then(response => response.data)
        .catch(error => {
            if(error.response.status === 401) {
                console.error("Unauthorized, clear store!");
                window.localStorage.removeItem("store");
                window.location.href = "/login";
            }
            return Promise.reject(error.response.data)
        });
}

export { fetchData, apiURL };
